import talentInfoReducer from "./reducers";
export { default as talentInfoTypes } from "./types";
export { default as talentInfoOperations } from "./operations";
export default talentInfoReducer;
